<template>
  <BaseLayout>
    <v-container fluid>
      <v-layout justify-center>
        <v-flex xs12 sm12 lg9>
          <v-card>
            <v-card-title>
              <h3 class="display-1">Geschäfte</h3>
            </v-card-title>
            <v-card-text>
              <v-layout align-center wrap>
                <h3>Filtern nach: </h3>
                <v-spacer />
                <v-flex xs12 sm3 :mr-4="$vuetify.breakpoint.smAndUp">
                  <v-select v-model="filter.kind" :items="kinds" label="Geschäftsart" clearable />
                </v-flex>
                <v-flex xs12 sm3>
                  <v-select v-model="filter.status" :items="statuses" label="Status" clearable />
                </v-flex>
              </v-layout>
              <BusinessTable
                :businesses="businesses"
              ></BusinessTable>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
      <v-btn
        v-if="$isSuperuser()"
        :to="{ name: 'new-business' }"
        color="green"
        dark
        fixed
        bottom
        right
        fab
      >
        <v-icon>add</v-icon>
      </v-btn>
    </v-container>
  </BaseLayout>
</template>

<script>
import Business from '@/models/business';

export default {
  name: 'IndexBusiness',
  async asyncData() {
    await Business.fetchAll();
  },
  data() {
    return {
      filter: {
        kind: null,
        status: null,
      },
    };
  },
  computed: {
    businesses() {
      return Business
        .query()
        .where(v => this.filter.kind && v.kind === this.filter.kind)
        .where(v => this.filter.status && v.status === this.filter.status)
        .all();
    },
    kinds() { return Business.kinds; },
    statuses() { return Business.statuses; },
  },
};
</script>
